__turbopack_context__.v({
  "className": "bebas_neue_9fe3638f-module__6YDOYq__className",
});
